
import { mapState } from 'vuex';
import PageHeader from '@justeat/f-header';
import CookieBanner from '@justeat/f-cookie-banner';
import mountDetector from '@/mixins/mountDetector.vue';

export default {
    components: {
        PageHeader,
        CookieBanner
    },

    mixins: [
        mountDetector
    ],

    computed: {
        ...mapState('globalisation', [
            'locale'
        ]),

        ...mapState('header', [
            'navigationDisabled'
        ])
    },

    created () {
        this.$root.$i18n.locale = this.locale;
    }
};
